/**
 * Shared award-decision terminology and configuration. Centralised so the
 * unsuccessful-decision wording can never drift to "Declined" (PRO-572 hard
 * requirement) and the upload/validation rules stay consistent across drawers.
 *
 * PRO-655 supersedes the earlier "Not Awarded" wording with "Unsuccessful" —
 * the "never Declined" contract itself is unchanged.
 */

/** User-facing label for the unsuccessful decision. NEVER "Declined". */
export const NOT_AWARDED_LABEL = "Unsuccessful";
export const MARK_NOT_AWARDED_LABEL = "Unsuccessful";
export const AWARD_LABEL = "Preferred";

/**
 * Outcome-aware confirmation-dialog copy (PRO-655). The dialog title/body
 * differ for the positive vs. negative decision; the confirm button text is
 * shared across both.
 */
export const CONFIRM_DECISION_TITLE_PREFERRED = "Notification to Preferred Supplier";
export const CONFIRM_DECISION_TITLE_UNSUCCESSFUL =
	"Notification to Unsuccessful Supplier(s)";
export const CONFIRM_DECISION_BODY_PREFERRED =
	"Preferred supplier will be notified by email. This cannot be undone once confirmed - are you sure you want to continue?";
export const CONFIRM_DECISION_BODY_UNSUCCESSFUL =
	"Unsuccessful supplier(s) will be notified by email. This cannot be undone once confirmed - are you sure you want to continue?";
export const CONFIRM_DECISION_CONFIRM_LABEL = "Continue & Send";

// Error helpers live at feature level (utils/awardErrors) so the mutation hooks
// can share them; re-exported here for the drawers that already import from this
// module.
export {
	AWARD_DECISION_FINAL_CODE,
	getAwardErrorCode,
	isAwardDecisionFinal,
} from "../../../utils/awardErrors";

/** Max length of the optional decision reason (matches the `comment` rule). */
export const REASON_MAX_LENGTH = 10000;

/** Contract upload — accepted extensions and size cap (client-side, F4). */
export const CONTRACT_ACCEPTED_EXTENSIONS = ["pdf", "doc", "docx"] as const;
export const CONTRACT_MAX_SIZE_MB = 50;
